import React from 'react';
import { Typography } from 'app/components/ui';

export const LabeledSection = ({ label, children, style }: { label: string; children: React.ReactNode; style?: React.CSSProperties }) => {
  return (
    <div>
      <Typography variant="body-3" fontWeight="semibold" color="#717077" className="mb-1">
        {label}
      </Typography>
      <div style={style ?? { display: 'grid', gap: '0.5rem' }}>{children}</div>
    </div>
  );
};
